module.exports = __webpack_public_path__ + "img/1x.3ea6fba.jpg";